var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 19.0984C20.8534 19.0984 20.9073 19.0922 20.9607 19.08C21.1141 19.0436 21.2508 18.9565 21.3487 18.8328C21.4465 18.7091 21.4999 18.5561 21.5 18.3984C21.5 12.0375 20.6954 6.7472 11 6.50658V1.59835C11 1.46226 10.9603 1.32912 10.8858 1.21523C10.8113 1.10134 10.7052 1.01164 10.5805 0.957099C10.4558 0.902562 10.3179 0.885556 10.1837 0.908162C10.0495 0.930768 9.92482 0.992005 9.82488 1.08438L0.724876 9.48438C0.581375 9.61615 0.5 9.80288 0.5 9.99835C0.5 10.1938 0.581375 10.3806 0.724876 10.5125L9.82488 18.9125C9.92469 19.0052 10.0495 19.0667 10.1838 19.0893C10.3182 19.1119 10.4562 19.0947 10.5809 19.0397C10.7055 18.9851 10.8115 18.8953 10.8859 18.7814C10.9604 18.6675 11 18.5344 11 18.3984V13.5066C17.6507 13.6658 18.8778 16.1193 20.1739 18.7114C20.232 18.8277 20.3213 18.9255 20.4319 18.9939C20.5425 19.0622 20.67 19.0984 20.8 19.0984ZM10.3 12.0984C9.91308 12.0984 9.6 12.4114 9.6 12.7984V16.7994L2.23215 9.99835L9.6 3.19733V7.19835C9.6 7.58528 9.91308 7.89835 10.3 7.89835C18.0329 7.89835 19.698 10.8891 20.0255 15.6661C18.5756 13.7185 16.1044 12.0984 10.3 12.0984Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.87497de89413c2afeea9ce58fb8a89b1.svg";
export { ForwardRef as ReactComponent };